"use strict";
var Observable_1 = require('../../Observable');
var mergeAll_1 = require('../../operator/mergeAll');
Observable_1.Observable.prototype.mergeAll = mergeAll_1.mergeAll;
//# sourceMappingURL=mergeAll.js.map


// WEBPACK FOOTER //
// ./techpad-upgrade/~/rxjs/add/operator/mergeAll.js